// Menu - Configure
import {adminRoutes} from '../../../utility/route-locations';
import CreditPackages from './config/CreditPackages';
import RegistrationPackages from './config/RegPackages';
import LegalDocuments from './config/LegalDocuments';
import CreditEnquiry from './reports/CreditEnquiry';
import PackageSales from './reports/PackageSales';
import CreditUtilization from './reports/CreditUtilization';
import UnconfirmedPurchases from './reports/UnconfirmedPurchases';
import TransactionSearch from './reports/TransactionSearch';
import TaxRates from './config/TaxRates';
import SalesReport from './reports/SalesReport';
import TaxReport from './reports/TaxReport';
import RevenueReport from './reports/RevenueReport';
import CompanyDetails from './config/CompanyDetails';
import Notifications from './config/Notifications';
import ManageUsers from "../configure/company/ManageUsers";
import CreditBuckets from "./credits/CreditBuckets";
import {roleNames} from "../configure/company/user-util";
import CustomerCredits from "./credits/CustomerCredits";
import MyDetails from "../my-details/MyDetails";
import EmailRecipients from "./config/EmailRecipients";


const bynxMenuStructure = {
  groups: [{
    name: 'config',
    titleId: 'config',
    items: [
      {
        name: 'credit-packages',
        titleId: 'creditPackages',
        path: adminRoutes.admin_credit_packages,
        component: CreditPackages,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'registration-packages',
        titleId: 'registrationPackages',
        path: adminRoutes.admin_reg_packages,
        component: RegistrationPackages,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'legal-documents',
        titleId: 'legalDocuments',
        path: adminRoutes.admin_legal_documents,
        component: LegalDocuments,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'tax-rates',
        titleId: 'taxRates',
        path: adminRoutes.admin_tax_rates,
        component: TaxRates,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'company-details',
        titleId: 'contactDetails',
        path: adminRoutes.admin_company_details,
        component: CompanyDetails,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'notifications',
        titleId: 'notifications',
        path: adminRoutes.admin_notifications,
        component: Notifications,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'users',
        titleId: 'identity',
        path: adminRoutes.admin_configure_users,
        component: ManageUsers,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN, roleNames.COMPANY_ADMIN],
      },
      {
        name: 'email-recipients',
        titleId: 'emailRecipients',
        path: adminRoutes.admin_configure_recipients,
        component: EmailRecipients,
        allowedRoleNames: [roleNames.COMPANY_ADMIN],
      },       
      {
        name: 'settings',
        titleId: 'accountSettings',
        path: adminRoutes.admin_configure_settings,
        component: MyDetails,
        
      },
    ],
  }, {
    name: 'credits',
    titleId: 'creditAllocation',
    items: [
      {
        name: 'company-buckets',
        titleId: 'manageCompany',
        path: adminRoutes.admin_credit_buckets,
        component: CreditBuckets,
        allowedRoleNames: [roleNames.CONSOLE_FINANCE],
      },
      {
        name: 'customer-alloc',
        titleId: 'allocateCredits',
        path: adminRoutes.admin_credit_alloc,
        component: CustomerCredits,
        allowedRoleNames: [roleNames.COMPANY_FINANCE],
      },
    ],
  }, {
    name: 'reports',
    titleId: 'reports',
    items: [
      {
        name: 'credit-enquiry',
        titleId: 'creditEnquiry',
        path: adminRoutes.admin_credit_enquiry,
        component: CreditEnquiry,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'package-sales',
        titleId: 'packageSales',
        path: adminRoutes.admin_package_sales,
        component: PackageSales,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'unconfirmed-purchases',
        titleId: 'unconfirmedSales',
        path: adminRoutes.admin_unconfirmed_purchases,
        component: UnconfirmedPurchases,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'credit-utilization',
        titleId: 'creditUtilisation',
        path: adminRoutes.admin_credit_utilization,
        component: CreditUtilization,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'transaction-search',
        titleId: 'transactionSearch',
        path: adminRoutes.admin_transaction_search,
        component: TransactionSearch,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'sales-report',
        titleId: 'salesReport',
        path: adminRoutes.admin_sales_report,
        component: SalesReport,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'tax-report',
        titleId: 'taxReport',
        path: adminRoutes.admin_tax_report,
        component: TaxReport,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
      {
        name: 'revenue-report',
        titleId: 'revenueReport',
        path: adminRoutes.admin_revenue_report,
        component: RevenueReport,
        allowedRoleNames: [roleNames.CONSOLE_ADMIN],
      },
    ],
  }],
};

export default bynxMenuStructure;
